import React from 'react';
import {
    useTable,
    useSortBy
} from 'react-table';
import {Table, Row, Col, Input, CustomInput} from 'reactstrap';
import { useTranslation } from "react-i18next";
import Aux from '../../../../hoc/Auxiliary';

const TableContainer = ({columns, data }) => {
    const { t } = useTranslation();

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,
    } = useTable(
        {
            columns,
            data,
            rows,
            disableSortRemove: true,
        },
        useSortBy
    );

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (column.isSortedDesc ? <i className="fa fa-angle-down"></i> :
            <i className="fa fa-angle-up"></i>) : '';
    };

    return (
        <Aux>
            <div className="table-wrapper">
                <Table hover {...getTableProps()} className="datatable datatable--communications">
                    <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    <div {...column.getSortByToggleProps({title: t(`docs.togglesortby`)+' '+column.render("Header")})}>
                                        {column.render('Header')}
                                        {generateSortingIndicator(column)}
                                    </div>
                                    { /*<Filter column={column} /> */}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <Aux key={row.getRowProps().key}>
                                <tr>
                                    {row.cells.map((cell) => {
                                        return (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        );
                                    })}
                                </tr>
                            </Aux>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
        </Aux>
    );
};

export default TableContainer;
